import React, { useState, useEffect } from 'react';
import LessonPlan from '../components/LessonPlan/LessonPlan';

/**
 * LessonPlan Page Component
 * Main page that renders the LessonPlan component
 * Replaces the Angular routing to the lesson plan functionality
 */
const LessonPlanPage = ({ moduleId, moduleSemesterId: propModuleSemesterId, ...otherProps }) => {
  const [moduleSemesterId, setModuleSemesterId] = useState(propModuleSemesterId || moduleId || null);

  useEffect(() => {
    // If moduleSemesterId is passed as prop, use it (from socrates-ui.js)
    if (propModuleSemesterId || moduleId) {
      const id = propModuleSemesterId || moduleId;
      setModuleSemesterId(id);
      return;
    }

    // Extract module semester ID from URL hash
    // React format: #LessonPlans/{moduleSemesterId}
    const extractModuleSemesterIdFromHash = () => {
      const hash = window.location.hash;
      if (hash.startsWith('#LessonPlans/')) {
        const id = hash.replace('#LessonPlans/', '');
        return id;
      }
      return null;
    };

    // Get module semester ID from URL or use a default
    const idFromHash = extractModuleSemesterIdFromHash();
    if (idFromHash) {
      setModuleSemesterId(idFromHash);
    } else {
      // Check if there's any module semester ID in URL parameters or try extracting from other sources
      const urlParams = new URLSearchParams(window.location.search);
      const paramId = urlParams.get('moduleSemesterId') || urlParams.get('msId');
      
      if (paramId) {
        setModuleSemesterId(paramId);
      } else {
        // Fallback: try to get from cookies or other source
        console.warn('No module semester ID found in URL hash or parameters.');
        setModuleSemesterId(null); // Don't use placeholder, let user know there's an issue
      }
    }

    // Listen for hash changes to update the module semester ID
    const handleHashChange = () => {
      const newId = extractModuleSemesterIdFromHash();
      if (newId) {
        setModuleSemesterId(newId);
      }
    };

    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [propModuleSemesterId, moduleId]);

  if (!moduleSemesterId) {
    return (
      <div className="container">
        <div className="alert alert-warning">
          <h4>No Module Selected</h4>
          <p>Please select a module to view its lesson plan.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <LessonPlan moduleSemesterId={moduleSemesterId} />
    </div>
  );
};

export default LessonPlanPage; 